import React from "react";
import "../styles/WhyChooseUs.css";

const WhyChooseUsSection = () => {
  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/919024000691?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/919024000691?text=${encodedMessage}`;
  return (
    <>
    <section className="why-choose-us-section">
      <h2 className="why-choose-us-title">Why Choose <span className="highlight">Reddy Anna</span> for Unmatched <span className="highlight">Gaming Excitement?</span> </h2>
      <p className="why-choose-us-description">
      At Reddy Anna Book, we redefine online gaming by delivering an exceptional experience tailored for enthusiasts. With a wide selection of engaging games, advanced technology, and a strong focus on responsible gaming, we provide a secure and exhilarating platform for all users. Choose Reddy Anna for an unparalleled gaming adventure where fun and safety are our top priorities. Join us today and experience what makes Reddy Anna the ultimate destination for online entertainment.
      </p>
      <div className="why-choose-us-cards">
        <div className="why-choose-us-card orange">
          <div className="icon-container "><img src="people.webp" alt="Icon"></img></div>
          <h3>Already Joined 40K+ users and enjoying.</h3>
        </div>
        <div className="why-choose-us-card green">
          <div className="icon-container "><img src="lock.webp" alt="Icon"></img></div>
          <h3>Your Information is 100% Secured with us.</h3>
        </div>
        <div className="why-choose-us-card blue">
          <div className="icon-container "><img src="clock.webp" alt="Icon"></img></div>
          <h3>24-hour withdrawal available (unlimited time).</h3>
        </div>
        <div className="why-choose-us-card orange">
          <div className="icon-container"><img src="protection.webp" alt="Icon"></img></div>
          <h3>100% Genuine and Secured.</h3>
        </div>
        <div className="why-choose-us-card green">
          <div className="icon-container"><img src="customer.webp" alt="Icon"></img></div>
          <h3>24x7 customer service available. No need to Worry!</h3>
        </div>
      </div>
      <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="contactus-button"
          >
            Open Your Demo Account
          </a>
          <a
            href={ContactLink}
            target="_blank"
            rel="noopener noreferrer"
            className="contactus-button"
          >
            Contact Us Now
          </a>
    </section>
    </>
  );
};

export default WhyChooseUsSection;
